<template>
    <b-card no-body>
        <v-table    ref="table"
                    :buttons="buttons"
                    name="agreement"
                    :fields="fields"
                    :items-provider="provider"
                    search
                    pagination="server"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import AgreementApi from '@/api/agreement'
export default {
    components:{
        BCard
    },
    data(){
        return{
            fields:[
                { name:'Sözleşme No', key:'AgreementCode', thClass:'w-20',sortable:true },
                { name:'Teklif No', key:'DraftCode', thClass:'w-20',sortable:true, sortKey:'CustomerDraftOffer.PreparedDraftOffer.DraftCode' },
                { name:'Firma', key:'FirmName',thClass:'w-20',sortable:true,sortKey:'CustomerDraftOffer.PreparedDraftOffer.Firm.Name' },
                { name:'Firma Lokasyonu', key:'LocationName',thClass:'w-20',sortable:true, sortKey:'CustomerDraftOffer.FirmLocation.LocationName' },
                { name:'Oluşturan', key:'CreatedByUserName',thClass:'w-10',sortable:true, sortKey:'CustomerDraftOffer.PreparedDraftOffer.CreatedByUser.FirstName' },
                { name:'Oluşturulma Tarihi', key:'CreateTimeStr',thClass:'w-10',sortable:true,sortKey:'CreateTime' },
                { name:'Kabul Tarihi', key:'AcceptedDate',thClass:'w-20',sortable:true },
                { name:'Sözleşme Bitiş Tarihi', key:'ExpireDate',thClass:'w-20',sortable:true },
                { name:"Durum",component:true,componentOptions:{name:"agreement-status/AgreementStatus"}},
            ],
            buttons:[
                { text:"Detay Görüntüle",key:"detail",icon:"EyeIcon",variant:"primary",action:this.detail,condition:(item)=> item.Status != 0  },
            ]
        }
    },
    methods:{
        provider(data){
            return AgreementApi.Table(data)
        },
        detail(item){
            this.$router.push({name:'agreement-detail',params:{id:item.Id}})
        }
    }
}
</script>

<style>

</style>